import React, { useState } from "react";
import { Link } from "react-router-dom";
import NewPropertySearchControl from "../components/newpropertysearchcontrol";
import OurPartners from "../components/ourpartners";
import CTA from "../components/cta";
function Developers() {
  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(1);

  const fetchListings = (pageNo, reset = false, payload = {}) => {
    console.log("Fetching listings...", pageNo, payload);
    // your API call here
  };

  const handleSearch = (payload) => {
    setFilters(payload);
    setPage(1);

    fetchListings(1, false, payload);

    const queryStr = new URLSearchParams(payload).toString();
    window.history.replaceState(null, "", `/new-projects?${queryStr}`);
  };

  return (
    <>
      <section
    className="flat-title-page mrg-0 boder-r-0"
    style={{
      backgroundImage:
        "url(images/img/developer-banner.jpg)"
    }}
  >
    <div className="container">
      <div className="breadcrumb-content">
        <h1 className="text-center text-white title">Developers</h1>
         <div className="container">
        <section
          className="flat-filter-search-v2-newproject searchcontrolbox flat-section flat-recommended pt-0"
          style={{ marginTop: 2 }}
        > 
            <NewPropertySearchControl
              defaultValues={filters}
              onSearch={handleSearch}
            /> 
        </section>
      </div>
      </div>
    </div>
  </section>
     
<div className="container">      
<section className="flat-section flat-recommended pt-0">
    <div className="container">
      <div
        className="box-title-listing"
        style={{ visibility: "visible" }}
      >
        <h3 className="title mt-4">Top Developers in Abu Dhabi</h3>
      </div>
      <div className="row">
         <OurPartners city="Abu Dhabi"/>
      </div>
    </div>
  </section>
  <hr />
  <section className="flat-section flat-recommended pt-0">
    <div className="container">
      <div
        className="box-title-listing"
        style={{ visibility: "visible" }}
      >
        <h3 className="title mt-4">Top Developers in Dubai</h3>
      </div>
    <div className="row">
         <OurPartners city="Dubai"/>
      </div>
    </div>
  </section>
</div>  
<CTA/>
    </>
  );
}

export default Developers;